"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setGeolocation;

function setGeolocation(_ref) {
  var lat = _ref.lat,
      lon = _ref.lon;
  return "".concat(lat, ";").concat(lon);
}


//////////////////
// WEBPACK FOOTER
// ./~/ics/dist/utils/set-geolocation.js
// module id = 593
// module chunks = 14